
export default class ConfirmationViewStyle {
    container: React.CSSProperties =
        {
            height: 368,
            background: '#ffffff',
            width: 670,
            borderRadius: 8,
            overflow: 'hidden',
            boxShadow: 'rgba(136, 152, 170, 0.25) 0px 0px 2rem 0px',
            display: 'flex'
        }

    box: React.CSSProperties =
        {
            paddingLeft: 86,
            paddingRight: 86,
            display: 'flex',
            alignItems: 'center',
            flexDirection: "column",
            justifyContent: 'center',
            height: 337,
            backgroundColor: '#1AA5CF',
            flex: 1,
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            overflow: 'hidden'
        }

    boxHeader: React.CSSProperties =
        {
            height: 90,
            color: 'white'
        }

    boxHeaderTitle: React.CSSProperties =
        {
            fontSize: 17,
            fontWeight: 300,
            textAlign: 'center'
        }

    boxHeaderBody: React.CSSProperties =
        {
            marginTop: 10,
            fontSize: 25,
            fontWeight: 400
        }

    boxFooter: React.CSSProperties =
        {
            height: 60,
            color: 'white',
            fontSize: 18,
            fontWeight: 300,
            marginTop: 10,
            textAlign: 'center'
        }

    image: React.CSSProperties =
        {
            width: 100,
            position: 'absolute',
            alignSelf: 'flex-end',
            paddingBottom: 23,
            transform: window.navigator.userAgent.indexOf("MSIE ") > 0 ? 'translate(-140px, 270px)' : 'translate(550px)',
            justifySelf: 'flex-end'
        }

    shellContainer: React.CSSProperties =
        {
            alignContent: 'center',
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
            height: 398,
            width: 670
        }

    backToHome: React.CSSProperties =
        {
            color: 'white',
            textAlign: 'center',
            fontSize: 11,
            marginTop: 25,
            cursor: 'pointer',
            alignSelf: 'center',
            textDecoration: 'underline'
        }
}
